import React, { ForwardedRef, forwardRef, ReactNode } from 'react';
import { GenericLink } from '@sato/components';

export interface ContentfulPageLinkProps {
  entryId?: string;
  urlId?: string;
  hash?: string;
  search?: string;
  children?: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const ContentfulPageLink = forwardRef(
  (
    {
      children,
      urlId,
      search = '',
      hash = '',
      className,
      ...rest
    }: ContentfulPageLinkProps,
    ref: ForwardedRef<HTMLAnchorElement>
  ) => {
    // try to resolve urlId without entryId

    return (
      <GenericLink
        {...rest}
        // override onMouseOver if necessary
        href={`${urlId}${search}${hash}`}
        className={className}
        ref={ref}
      >
        {children}
      </GenericLink>
    );
  }
);
